<template>
  <div style="overflow-y: auto;">
    <div class="pl-1">
      <v-progress-linear
        indeterminate
        color="primary"
        class="pl-1"
        v-if="!fetched"
      ></v-progress-linear>
    </div>
    <span v-if="intervalGroupedByCars.length===0 && fetched">
      <v-alert outlined color="primary" class="ma-1">
      {{ $t("common.no_data_available") }}
        </v-alert>
    </span>
    <v-simple-table v-else height="211">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">{{ $t("common.car") }}</th>
          <th class="text-left">
            {{ $t("common.repairtimes") }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="group in intervalGroupedByCars" :key="group.car_id">
          <td>
                    <span v-if="group.car">
          <v-tooltip
              bottom
              :disabled="!group.car.car_number || group.car.car_number == ''"
              style="cursor: auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <div class="d-flex align-center" v-bind="attrs" v-on="on">
                <div>
                  <img
                      align="center"
                      class="brandLogoMiddle mr-1"
                      v-if="!!brandURL(group.car.brand)"
                      :src="brandURL(group.car.brand)"
                      :title="group.car.brand && group.car.brand.toUpperCase()"
                  />
                  <span v-else class="">
                    {{ group.car && group.car.brand.toUpperCase() }}
                  </span>
                </div>
                <span class="">
                  {{ group.car.brand }} {{ group.car.family }}
                  {{ group.car.model }}
                </span>
              </div>
            </template>
            <beauty-car-number
                v-if="group.car.car_number && group.car.car_number !== ''"
                :number="group.car.car_number ? group.car.car_number : ''"
                class="d-inline-block small"
            />
          </v-tooltip>
        </span>
            <span v-else>{{ $t("windowFastOrder.error_no_car_selected") }}</span>
          </td>
          <td>
            <div v-for="interval in group.intervals" class="text-caption">
              {{ interval.start | moment("HH:mm") }} {{ interval.post.name }}:<br />
              <span
                  class="dashed"
                  @click.stop="
              orderWindow.orderId = interval.repairtime.order.id;
              orderWindow.isVisible = true;
            "
              >#{{ interval.repairtime.order.human_number }}</span
              >
              {{ interval.repairtime.name }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <strong v-bind="attrs" v-on="on">
                <span
                    :style="{
                    background: interval.repairtime.status.color,
                  }"
                    class="pa-1 d-inline-block mx-1 status-circle"
                ></span>
                  </strong>
                </template>
                {{
                  interval.repairtime.status.system
                      ? $t(
                          "common.orderPartsSystemStatusNames." +
                          interval.repairtime.status.name
                      )
                      : interval.repairtime.status.name
                }}
              </v-tooltip>
              <user-profile-photo
                  class="d-inline-flex"
                  :title="interval.repairer.name"
                  v-if="interval.repairer"
                  :profile-photo="interval.repairer.profile_photo"
                  :size="12"
              ></user-profile-photo>
            </div>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-list-item
      v-for="group in intervalGroupedByCars"
      class="d-block px-0 ml-2 mb-3"
      :key="group.car_id"
    >
      <div>
        <span v-if="group.car">
          <v-tooltip
            bottom
            :disabled="!group.car.car_number || group.car.car_number == ''"
            style="cursor: auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <div class="d-flex align-center" v-bind="attrs" v-on="on">
                <div>
                  <img
                    align="center"
                    class="brandLogoMiddle mr-1"
                    v-if="!!brandURL(group.car.brand)"
                    :src="brandURL(group.car.brand)"
                    :title="group.car.brand && group.car.brand.toUpperCase()"
                  />
                  <span v-else class="">
                    {{ group.car && group.car.brand.toUpperCase() }}
                  </span>
                </div>
                <span class="">
                  {{ group.car.brand }} {{ group.car.family }}
                  {{ group.car.model }}
                </span>
              </div>
            </template>
            <beauty-car-number
              v-if="group.car.car_number && group.car.car_number !== ''"
              :number="group.car.car_number ? group.car.car_number : ''"
              class="d-inline-block small"
            />
          </v-tooltip>
        </span>
        <span v-else>{{ $t("windowFastOrder.error_no_car_selected") }}</span>
        <div v-for="interval in group.intervals" class="text-caption">
          {{ interval.start | moment("HH:mm") }} {{ interval.post.name }}:<br />
          <span
            class="dashed"
            @click.stop="
              orderWindow.orderId = interval.repairtime.order.id;
              orderWindow.isVisible = true;
            "
            >#{{ interval.repairtime.order.human_number }}</span
          >
          {{ interval.repairtime.name }}
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <strong v-bind="attrs" v-on="on">
                <span
                  :style="{
                    background: interval.repairtime.status.color,
                  }"
                  class="pa-1 d-inline-block mx-1 status-circle"
                ></span>
              </strong>
            </template>
            {{
              interval.repairtime.status.system
                ? $t(
                    "common.orderPartsSystemStatusNames." +
                      interval.repairtime.status.name
                  )
                : interval.repairtime.status.name
            }}
          </v-tooltip>
          <user-profile-photo
            class="d-inline-flex"
            :title="interval.repairer.name"
            v-if="interval.repairer"
            :profile-photo="interval.repairer.profile_photo"
            :size="12"
          ></user-profile-photo>
        </div>
      </div>
    </v-list-item>
    <order-window
      :is-visible="orderWindow.isVisible"
      :order-id="orderWindow.orderId"
      @hide="
        orderWindow.orderId = null;
        orderWindow.isVisible = false;
      "
      @update="getData"
    />
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import BeautyCarNumber from "@/components/common/BeautyCarNumber.vue";
import UserProfilePhoto from "@/components/user/UserProfilePhoto.vue";
import OrderWindow from "@/components/order/OrderWindow.vue";

export default {
  name: "MainWidgetIntervals",
  components: { OrderWindow, UserProfilePhoto, BeautyCarNumber },
  data: () => ({
    orderWindow: {
      orderId: null,
      isVisible: false,
    },
  }),
  mounted() {
    this.getData();
  },
  mixins: [CommonMixin],
  computed: {
    ...mapFields("intervals", ["intervals", "fetched"]),
    ...mapFields("statuses", [
      "order_statuses",
      "order_repairtimes_statuses",
      "order_payments_statuses",
    ]),
    intervalGroupedByCars() {
      let result = [];
      this.intervals.forEach((interval) => {
        let carId =
          (interval.repairtime &&
            interval.repairtime.order &&
            interval.repairtime.order &&
            interval.repairtime.order.car &&
            interval.repairtime.order.car.id) ||
          null;
        let carData = result.find((group) => group.car_id === carId);
        if (!carData) {
          carData = {
            car_id: carId,
            car:
              (interval.repairtime &&
                interval.repairtime.order &&
                interval.repairtime.order &&
                interval.repairtime.order.car) ||
              null,
            intervals: [],
          };
          carData.intervals.push(interval);
          result.push(carData);
        } else {
          carData.intervals.push(interval);
        }
      });
      return result;
    },
  },
  methods: {
    getData() {
      let to = new Date();
      let date = to.toISOString().split("T")[0];
      //date = '2023-08-11'
      this.$store.dispatch("intervals/get", { date: date });
    },
  },
};
</script>

<style scoped>
.brandLogoMiddle {
  width: 16px;
}
</style>
